import React, { useEffect, useCallback, useState} from 'react';
import ipfs from 'decentralized/Ipfs.js';
import {getSamplePack} from 'decentralized/artists/Artists.js';
import {setUploadingFile} from 'actions/index.js';
import {SAMPLE_PACK} from 'constants/release-types.js';
import {connect} from 'react-redux';
import {downloadImage} from 'utils/downloadImage.js';
import ImageHandler from "components/explore/lists/ImageHandler.js"


const SamplePackFlow = ({track, sample, setUploadingFile, guildId}) => { 
    const [artistName, setArtistName] = useState('');
    const [name, setName] = useState('');
    const [coverArtUrl, setCoverArtUrl] = useState('');
    const [samplePack, setSamplePack] = useState(undefined);
    const [editedCoverArt, setEditedCoverArt] = useState(false);
    const [copiedAll, setCopiedAll] = useState(false);

    useEffect(() => {
        if (sample.copiedAll) {
            setCopiedAll(true);
        }
    }, [sample, setCopiedAll]);

    useEffect(() => {
        // check if this sample pack exists already, and if so auto fill
        // the cover art hash
        getSamplePack(artistName, name)
            .then(samplePack => {
                if (samplePack) {
                    setName(samplePack.releaseName);
                    setCoverArtUrl(samplePack.coverArtHash);
                    setSamplePack(samplePack);
                } else {
                    setSamplePack(undefined);
                }
            });
    }, [artistName, name, setName, setCoverArtUrl, setSamplePack]);

    const copyToAll = useCallback(() => {
        let coverArtHash = "";
        if (coverArtUrl && editedCoverArt) {
            coverArtHash = coverArtUrl;
        } else if (samplePack && samplePack.coverArtHash) {
            coverArtHash = samplePack.coverArtHash;
        } 

        for (let _track of track.sequencerEngine.tracks) {
            let _sample = _track.sample;
            if (sample.tags) {
                _sample.tags = [...sample.tags];
            }
            if (samplePack) {
                window.sessionStorage.setItem("getSamplePack(" + artistName + ',' + name+ ")", JSON.stringify(samplePack));
                if (!samplePack.releaseId) {
                    _sample.discogsId =  Math.floor(new Date().getTime() / 10000);
                } else {
                    _sample.discogsId = samplePack.releaseId;
                }
            } else {
                _sample.discogsId = Math.floor(new Date().getTime() / 10000);
            }
            _sample.releaseType = SAMPLE_PACK;
 
            _sample.coverArtHash = coverArtHash;
            _sample.releaseName = name;
            _sample.artistName = artistName;
            _sample.year = 0;
            _sample.styles = [];
            _sample.country = "";
            _sample.copiedAll = true;
        }
        setCopiedAll(true);
    }, [sample, name, coverArtUrl, editedCoverArt, samplePack, setCopiedAll]);

    const saveWithCoverArt = useCallback((hash) => {
        sample.coverArtHash = hash;
        sample.releaseName = name;
        sample.artistName = artistName;
        sample.year = 0;
        sample.styles = [];
        sample.country = "";
        
        // since this isnt actually from discogs we use the current
        // time stamp as the discogs id
        if (samplePack) {
            window.sessionStorage.setItem("getSamplePack(" + artistName + ',' + name+ ")", JSON.stringify(samplePack));
            if (!samplePack.releaseId) {
                sample.discogsId =  Math.floor(new Date().getTime() / 10000);
            } else {
                sample.discogsId = samplePack.releaseId;
            }
        } else {
            sample.discogsId = Math.floor(new Date().getTime() / 10000);
        }
        sample.releaseType = SAMPLE_PACK;
        setUploadingFile(true);
        
        setTimeout(async () => {
            await sample.saveSample(guildId);
            setUploadingFile(false);
        }, 100);
    }, [artistName, name, sample, samplePack, guildId]);

    const saveAll = useCallback(() => {
        setUploadingFile(true);
        setTimeout(async () => {
            for (let _track of track.sequencerEngine.tracks) {
                await _track.sample.saveSample(guildId);
            }
            setUploadingFile(false);
        }, 100);
    }, [track, guildId]);
    

    const saveSample = useCallback((e) => {
        if (coverArtUrl && editedCoverArt) {
            saveWithCoverArt(coverArtUrl);
        } else if (samplePack && samplePack.coverArtHash) {
            saveWithCoverArt(samplePack.coverArtHash);
        } else {
            saveWithCoverArt(undefined);
        }
    }, [name, artistName, coverArtUrl, sample, samplePack, guildId, editedCoverArt]);

    useEffect(() => {
        setSamplePack(undefined);
    }, [setSamplePack, sample]);

    return (
        <div className="sample-pack-flow">
          <div className="input-container">
            <div className="input-type">
              Artist Name:
            </div>
            <input
              value={artistName}
              onChange={(e) => setArtistName(e.target.value)}
              type="text"
              className="sample-pack-name-input"/>
          </div>
          <div className="input-container">
            <div className="input-type">
              Sample Pack:
            </div>
            <input
              value={name}
              onChange={(e) => setName(e.target.value)}
              type="text"
              className="sample-pack-name-input"/>
          </div>

          <ImageHandler placeholder="Drag cover art here" imageHash={coverArtUrl} setImageHash={(e) => {
                  setCoverArtUrl(e);
                  setEditedCoverArt(true);
              }}/>

          {!copiedAll ?
           <div
              onClick={saveSample}
              className={artistName === "" ? "save-button disabled" : "save-button"}>
              Save
           </div> : ''}
          {copiedAll ?
           <div onClick={saveAll} className="save-button">
             Save All
           </div> :
           <div onClick={copyToAll} className="save-button">
             Copy To All Tracks
           </div>}
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
      guildId: state.guilds.selectedGuild ? state.guilds.selectedGuild.guildId : 0
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setUploadingFile: (a) => dispatch(setUploadingFile(a)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SamplePackFlow);
